import Layout from "../../../../src/components/layout";
import { Link } from "gatsby";
import styled from "styled-components";
import { PrimaryButton } from "../../../../src/components/Buttons";
import { SecondaryButton } from "../../../../src/components/Buttons";
import YearMinus15 from "../../../../src/components/YearMinus15";
import React from 'react';
export default {
  Layout,
  Link,
  styled,
  PrimaryButton,
  SecondaryButton,
  YearMinus15,
  React
};